import { css } from 'styled-components';
import { FontSize14, FontSize16, Spacing8, Spacing16, Spacing24 } from 'autogen/design-tokens/tokens';
import { mediaQueryStyling } from 'helpers/mediaQueryStyling';
import { rem } from 'modules/helpers/style';
import type { ChipProps } from './types';

const chipSizes = {
    sm: css`
        font-size: ${FontSize14};
        height: ${rem(32)};
        padding-left: ${rem(Spacing8)};
        padding-right: ${rem(Spacing8)};
        border-radius: ${rem(32 / 2)};
    `,
    md: css`
        font-size: ${FontSize14};
        height: ${rem(40)};
        padding-left: ${rem(Spacing16)};
        padding-right: ${rem(Spacing16)};
        border-radius: ${rem(40 / 2)};
        
    `,
    lg: css`
        font-size: ${FontSize16};
        height: ${rem(48)};
        padding-left: ${rem(Spacing24)};
        padding-right: ${rem(Spacing24)};
        border-radius: ${rem(48 / 2)};
    `
};
export type ChipSizeKeys = keyof typeof chipSizes;

export function getChipSizesMediaQueryStyling<T extends {}>(sizesObject: T) {
    const newSizesObject = { ...sizesObject }; // Create a shallow copy

    Object.keys(newSizesObject).forEach((key) => {
        if (chipSizes[newSizesObject[key]]) {
            newSizesObject[key] = chipSizes[newSizesObject[key]];
        } else {
            // Handle the case where the size key does not exist
            console.warn(`Size key "${newSizesObject[key]}" is not defined in chipSizes.`);
        }
    });

    return mediaQueryStyling(newSizesObject);
}

export const chipSizeStyling = css<{ $size: ChipProps['size'] }>`
    ${({ $size }) => $size && (typeof $size === 'object' ? getChipSizesMediaQueryStyling($size) : chipSizes[$size])}
`;
